import React from 'react'
import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import Sidebar from '../../components/SideBar'
import { Link } from 'react-router-dom'

import AssinaturaVitalíciaPremium from '../../assets/icons/AssinaturaVitalíciaPremium.png'
import { Container } from './styles'
import { FiBookmark, FiCalendar, FiCompass, FiMap, FiWatch } from 'react-icons/fi'

const Premium: React.FC = () => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <Container>
        <img width={100} src={AssinaturaVitalíciaPremium} alt={'Assinatura Premium'} />
        <h2 className="title">
          Por que você deveria fazer o upgrade para a <strong>Vitalícia Premium</strong>?
        </h2>
        <p className="subtitle">
          Essa assinatura foi desenvolvida para quem busca uma orientação mais próxima e
          especializada com o que chamamos de <strong>SALA VIP</strong>
        </p>
        <h4>Como a SALA VIP pode te ajudar?</h4>
        <div className="items">
          <span>
            <FiBookmark size={24} className="icon" />
            Orientação sobre métodos de estudo
          </span>
          <span>
            <FiWatch size={24} className="icon" />
            Apoio na gestão do tempo
          </span>
          <span>
            <FiCompass size={24} className="icon" />
            Definição de estratégias para evitar distrações
          </span>
          <span>
            <FiCalendar size={24} className="icon" />
            Desenvolver a disciplina para uma rotina consistente de estudos
          </span>
          <span>
            <FiMap size={24} className="icon" />
            Informações específicas sobre áreas e concursos
          </span>
        </div>

        <div className="offer-container">
          <Link
            target="_blank"
            to={{
              pathname: 'http://wa.me/5561993590265',
            }}
            rel="noopener noreferrer"
          >
            CONFERIR OFERTA
          </Link>
        </div>
      </Container>
      <Footer />
    </>
  )
}

export default Premium
